module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_2_1-bdd4014e056bf61bacd6b2c3d03af6e8.png";